const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the user timeline component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to Analyze Resource
 * @argument {Content} Content injected to gain access to Content Resource
 * @argument {Tracks} Tracks injected to gain access to Tracks Resource
 * @argument {Events} Events injected to gain access to Events Resource
 * @argument {$q} $q injected to gain access to the $q promise module
 */
app.directive('activityFeed', ['Application', 'Authorization', '$q', 'Analyze', 'Viewables', 'Suggestions', 'Shares', 'MainComments', 'Users', '$translate', function (Application, Authorization, $q, Analyze, Viewables, Suggestions, Shares, MainComments, Users, $translate) {
    return {
      restrict: 'E',
      scope: {
        type: '@',
        user: '='
      },
      template: require('../../templates/directives/activity-feed.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.user = Authorization.getAuthToken().user;
        self.queryUser = $scope.user ? $scope.user : self.user._id;
        self.initialLoading = false;
        self.user = {
          session: Authorization.getAuthToken().user,
          query: $scope.user ? $scope.user : $scope.type === 'dashboard' ? Authorization.getAuthToken().user._id : null
        };
        self.translations = {};

        self.setConfig = function() {
          self.config = {
            api_options: ['comments', 'likes'],
            analyze_options: [],
            page: 1,
            per_page: 5
          };

          // social is limited to the above options
          if ($scope.type === 'dashboard') {
            self.config.api_options.push('shares');
            self.config.analyze_options = ['views', 'modifications', 'creations'];
          }

          self.communications.loading = false;
          self.communications.moreLoad = true;
          self.communications.moreAvailable = true;

          self.data.combined = {};
          self.data.active = [];
          self.data.content = {};
          self.data.presentations = {};

          self.config.api_options.forEach(self.status.setActive);
          self.config.analyze_options.forEach(self.status.setActive);
        };

        self.data = {
          tenseBlock: {
            'views': '',
            'creations': '',
            'modifications': '',
            'shares': '',
            'likes': '',
            'comments': ''
          },
          tenseIcons: {
            'views': 'view',
            'creations': 'created',
            'modifications': 'modified',
            'shares': 'shared',
            'likes': 'liked',
            'comments': 'comment'
          },
          gonePhrase: {
            'article': '',
            'video': '',
            'file': '',
            'track': '',
            'assessment': '',
            'presentation': '',
            'scorm-content': '',
            'imported_content': '',
            'event': '',
            'quiz': ''
          },
          availablePhrase: {
            'article': '',
            'video': '',
            'file': '',
            'track': '',
            'presentation': '',
            'scorm-content': '',
            'imported_content': '',
            'event': '',
            'assessment': '',
            'quiz': ''
          },
          pluralMap: {
            article: '',
            media: '',
            track: '',
            quiz: '',
            presentation: '',
            imported_content: '',
            event: '',
            assessment: ''
          },
          combined: {},
          active: [],
          content: {},
          presentations: {},
          prepareItem: function(item) {
            if (!item.contentType && !item.contentId) {
              item.contentType = item.content_type || item.type;
              item.contentId = item.document || item.content;
              if (!item.contentType || !item.contentId) {
                return null;
              }
            };

            // set tense items
            item.tense = self.data.tenseBlock[item.feedType] || self.translations["activityFeed.interaction_with"];
            item.tense_icon = self.data.tenseIcons[item.feedType];
            item.gonePhrase = self.data.gonePhrase[item.contentType] || self.translations["activityFeed.an_item"];
            item.availablePhrase = self.data.availablePhrase[item.contentType] || self.translations["activityFeed.an_item"];

            if (!item.created_on) {
              return null;
            }

            if (self.data.content[item.contentId]) {
              return null;
            }

            return {
              type: item.contentType,
              id: item.contentId
            };
          }
        };

        self.status = {
          setActive: function(item) {
            self.status[item] = true;
            self.data.combined[item] = [];
          }
        };

        self.communications = {
          loading: false,
          moreLoad: true,
          moreAvailable: true,
          apiGet: function() {
            var query = {
              page: self.config.page,
              per_page: self.config.per_page,
              user: self.user.query,
              sort: 'createdAt,-1',
              fields: 'article,media,track,presentation,imported_content,assessment,event,createdAt,user',
              'article-populate': 'title',
              'media-populate': 'title,type',
              'track-populate': 'name',
              'presentation-populate': 'title',
              'imported_content-populate': 'title',
              'assessment-populate': 'title',
              'event-populate': 'title'
            };
            var promises = [];
            var itemIndex = {};
            self.config.api_options.forEach(function(item) {
              if (!item || !self.status[item]) {
                return;
              }
              itemIndex[promises.length] = item;
              switch (item) {
                case 'likes':
                  promises.push(Suggestions.find(query).$promise);
                  break;
                case 'shares':
                  promises.push(Shares.find(query).$promise);
                  break;
                case 'comments':
                  promises.push(MainComments.find(query).$promise);
                  break;
                default:
                  break;
              }
            });

            return $q.all(promises)
            .then(function(results) {
              results.forEach(function(result, index) {
                if (result.length < self.config.per_page) {
                  self.status[itemIndex[index]] = false;
                }
                if (self.data.combined[itemIndex[index]]) {
                  for (var i = 0; i < result.length; i++) {
                    for (var key in self.data.pluralMap) {
                      if (result[i][key] && result[i][key]._id) {
                        result[i].contentType = key === 'media' && result[i][key].type ? result[i][key].type : key;
                        result[i].contentId = result[i][key]._id;
                        self.data.content[result[i][key]._id] = result[i][key];
                        break;
                      }
                    }
                  }
                  self.data.combined[itemIndex[index]] = self.data.combined[itemIndex[index]].concat(result);
                }
              });
              return results;
            }).catch(function(error) {
              console.log('error: ', error);
            });
          },
          analyzeGet: function() {
            var types = [];
            var query = {
              page: self.config.page,
              per_page: self.config.per_page,
              user: self.user.query
            };

            self.config.analyze_options.forEach(function(item) {
              if (self.status[item]) {
                types.push(item);
              }
            });

            if (!types.length) {
              return;
            }
            query.types = types.join(',');
            return Analyze.timeline(query).$promise
            .then(function(results) {
              for (var key in results) {
                if (results[key].length < self.config.per_page) {
                  self.status[key] = false;
                }
                if (self.data.combined[key]) {
                  self.data.combined[key] = self.data.combined[key].concat(results[key]);
                }
              }
              return results;
            }).catch(function(error) {
              console.log('error: ', error);
            });
          },
          load: function(initial) {
            self.communications.loading = true;
            $q.all([self.communications.apiGet(), self.communications.analyzeGet()])
            .then(function(items) {
              self.config.page++;
              self.communications.loading = false;
              if (!items[0] || !items[0].length) {
                self.communications.moreLoad = false;
                for (var i = 0; i < self.config.analyze_options.length; i++) {
                  if (items[1] && items[1][self.config.analyze_options[i]] && items[1][self.config.analyze_options[i]].length) {
                    self.communications.moreLoad = true;
                    break;
                  }
                }
              }
              if (initial) {
                self.communications.activate();
                self.initialLoading = false;
              }
            }).catch(function(error) {
              console.log('error: ', error);
            });
          },
          activate: function() {
            if (self.communications.loading) {
              return;
            }
            var count = 0;
            var active = [];
            var nextPrep = false;
            var content =[];
            while (count < self.config.per_page) {
              var newest = {};
              var item;
              for (var key in self.data.combined) {
                item = self.data.combined[key][0];
                if (!item) {
                  continue;
                }

                item.createdDate = item.createdAt ? new Date(item.createdAt).valueOf() : item.created_on ? new Date(item.created_on).valueOf() : 0;
                item.formattedDate = item.createdDate ? moment(new Date(item.createdDate)).fromNow() : '';
                if (!newest.item || item.createdDate > newest.item.createdDate) {
                  newest.item = item;
                  newest.key = key;
                }
              }
              if (newest.item && newest.key) {
                var addItem = self.data.combined[newest.key].shift(0);
                addItem.feedType = newest.key;
                content.push(self.data.prepareItem(addItem));
                active.push(addItem);
                if (self.data.combined[newest.key].length < self.config.per_page) {
                  nextPrep = true;
                }
              }
              count++;
            }
            self.content.get(content);
            self.data.active = self.data.active.concat(active);
            if (!active || !active.length) {
              self.communications.moreAvailable = false;
              return;
            }
            if (nextPrep) {
              if (!self.communications.moreLoad) {
                for (var key in self.data.combined) {
                  self.communications.moreAvailable = false;
                  if (self.data.combined[key] && self.data.combined[key].length) {
                    self.communications.moreAvailable = true;
                    return;
                  }
                }
                return;
              }
              self.communications.load();
            }
          }
        };

        self.content = {
          get: function(list) {
            if (!list || !list.length) {
              return;
            }
            var body = {viewables: []};
            list.forEach(function(item) {
              if (!item || !item.type || !item.id) {
                return;
              }
              body.viewables.push({type: item.type, id: item.id});
            });

            Viewables.titles({}, body).$promise
            .then(function(results) {
              results.forEach(function(item) {
                self.data.content[item.id] = {title: item.title};
              });
            });
          },
          goTo: function(item) {
            if (item.contentType === 'quiz') {
              return;
            }
            Application.navigation.goTo('/view/' + item.contentType + 's/' + item.contentId);
          }
        };

        self.initialize = function() {
          self.setConfig();
          self.initialLoading = true;
          self.communications.load(true);
          if (self.user.query === self.user.session._id) {
            self.user.name = 'You';
            moment.locale(self.user.session.language);
            $translate(["user.name.you"]).then(function (translation) {
              var localTranslation = translation;
              self.user.name = localTranslation["user.name.you"];
            });
          } else {
            Users.get({subresource: self.user.query, fields: 'first_name,last_name,email,role'}).$promise
            .then(function(user) {
              self.user.name = user.first_name;
              moment.locale(self.user.session.language);
            });
          }
        };

        $translate([
          "activityFeed.viewed",
          "activityFeed.created",
          "activityFeed.modified",
          "activityFeed.shared",
          "activityFeed.liked",
          "activityFeed.commented_on",
          "activityFeed.an_article",
          "activityFeed.a_video",
          "activityFeed.a_file",
          "activityFeed.a_track",
          "activityFeed.an_assessment",
          "activityFeed.a_presentation",
          "activityFeed.a_scorm_content",
          "activityFeed.vendor_content",
          "activityFeed.an_event",
          "activityFeed.a_quiz",
          "activityFeed.the_article",
          "activityFeed.the_video",
          "activityFeed.the_file",
          "activityFeed.the_track",
          "activityFeed.the_presentation",
          "activityFeed.the_scorm_content",
          "activityFeed.the_vendor ",
          "activityFeed.the_event",
          "activityFeed.the_assessment",
          "activityFeed.the_quiz",
          "activityFeed.articles",
          "activityFeed.media",
          "activityFeed.tracks",
          "activityFeed.quizzes",
          "activityFeed.presentations",
          "activityFeed.vendor_content",
          "activityFeed.events",
          "activityFeed.assessments",
          "activityFeed.interaction_with",
          "activityFeed.an_item"
        ]).then(function(translations){
          self.translations = translations;

          self.data.tenseBlock = {
            'views': self.translations["activityFeed.viewed"],
            'creations': self.translations["activityFeed.created"],
            'modifications': self.translations["activityFeed.modified"],
            'shares': self.translations["activityFeed.shared"],
            'likes': self.translations["activityFeed.liked"],
            'comments': self.translations["activityFeed.commented_on"]
          };
          self.data.gonePhrase = {
            'article': self.translations["activityFeed.an_article"],
            'video': self.translations["activityFeed.a_video"],
            'file': self.translations["activityFeed.a_file"],
            'track': self.translations["activityFeed.a_track"],
            'assessment': self.translations["activityFeed.an_assessment"],
            'presentation': self.translations["activityFeed.a_presentation"],
            'scorm-content': self.translations["activityFeed.a_scorm_content"],
            'imported_content': self.translations["activityFeed.vendor_content"],
            'event': self.translations["activityFeed.an_event"],
            'quiz': self.translations["activityFeed.a_quiz"]
          };
          self.data.availablePhrase = {
            'article': self.translations["activityFeed.the_article"],
            'video': self.translations["activityFeed.the_video"],
            'file': self.translations["activityFeed.the_file"],
            'track': self.translations["activityFeed.the_track"],
            'presentation': self.translations["activityFeed.the_presentation"],
            'scorm-content': self.translations["activityFeed.the_scorm_content"],
            'imported_content': self.translations["activityFeed.the_vendor"],
            'event': self.translations["activityFeed.the_event"],
            'assessment': self.translations["activityFeed.the_assessment"],
            'quiz': self.translations["activityFeed.the_quiz"]
          };
          self.data.pluralMap = {
            article: self.translations["activityFeed.articles"],
            media: self.translations["activityFeed.media"],
            track: self.translations["activityFeed.tracks"],
            quiz: self.translations["activityFeed.quizzes"],
            presentation: self.translations["activityFeed.presentations"],
            imported_content: self.translations["activityFeed.vendor_content"],
            event: self.translations["activityFeed.events"],
            assessment: self.translations["activityFeed.assessments"]
          };

          if ($scope.type === 'dashboard') {
            self.initialize();
            return;
          }

          // This is set only for non dashboard where the user is liable to change
          $scope.$watch('user', function(newVal, oldVal) {
            if (!newVal || newVal === oldVal) {
              return;
            }
            self.user.query = $scope.user;
            self.initialize();
          });

          if ($scope.user) {
            self.user.query = $scope.user;
            self.initialize();
          }

        });

      }],
      controllerAs: 'activity'
    };
  }]);

